<template>
  <div id="wrapper" class="page" v-if="salary_read">
    <div id="content-wrapper">
      <div id="salaries_payroll_fluid" class="container-fluid">
        <span style="display: inline;">
          <b-form-select
            v-model="year_selected"
            class="mb-2 mr-2"
            style="width: 10%"
            :options="optionsYear"
            value-field="value"
            text-field="text"
            @change="queryItem"
          />
          <b-form-select
            v-model="month_selected"
            class="mb-2 mr-2"
            style="width: 10%"
            :options="optionsMonth"
            value-field="value"
            text-field="text"
            @change="queryItem"
          />
        </span>
        <div>
          <b-row style="width: 100%;">
            <b-col cols="12">
              <b-table
                id="payroll-table"
                head-variant="dark"
                hover
                responsive
                striped
                small
                bordered
                sticky-header="true"
                :no-border-collapse="true"
                table-variant="light"
                :fields="payrollFields"
                :items="payrolls"
                selectable
                select-mode="single"
                @row-clicked="onRowClicked"
              >
                <template #cell(tenbangluong)="data"
                  >Bảng lương tháng {{ data.item.month }}/{{ data.item.year }} -
                  {{
                    findFirstDepartmentShort(
                      departments,
                      data.item.departmentid
                    )
                  }}</template
                >
                <template #cell(tong)="data">{{
                  data.item.tong | numeral("0,0")
                }}</template>
                <template #cell(departmentid)="data">
                  {{
                    findFirstDepartment(departments, data.item.departmentid)
                  }}</template
                >
                <template #cell(excel)="data">
                  <!-- <b-link
                    class="text-success"
                    href="#"
                    @click="
                      excelReportOld(
                        data.item.year,
                        data.item.month,
                        data.item.departmentid
                      )
                    "
                  >
                    <i class="far fa-file-excel"></i>
                  </b-link> -->
                  <b-link
                    class="text-warning"
                    style="margin-left: 10px;"
                    href="#"
                    @click="
                      excelReport(
                        data.item.year,
                        data.item.month,
                        data.item.departmentid
                      )
                    "
                  >
                    <i
                      class="far fa-file-excel"
                      v-b-tooltip.hover.bottomleft.html="{
                        title:
                          '<strong>Xuất payroll report theo template mới</strong>',
                      }"
                    ></i>
                  </b-link>
                </template>
                <template slot="bottom-row">
                  <td style="text-align:center" colspan="4">
                    <b>
                      TOTAL SALARY
                      <!-- TỔNG LƯƠNG -->
                    </b>
                  </td>
                  <td style="text-align:right">
                    <b>{{ sum_tong_luong_ck | numeral("0,0") }}</b>
                  </td>
                  <td style="text-align:center" colspan="2"></td>
                </template>
                <template slot="row-details">
                  <!-- <b-card
                    no-body
                    v-if="selected.length > 0"
                    style="width: 100%"
                  > -->
                  <b-card no-body style="width: 100%">
                    <b-table
                      bordered
                      head-variant="dark"
                      hover
                      responsive
                      striped
                      small
                      table-variant="light"
                      :fields="salaryFields"
                      :items="salaries"
                    >
                      <template #cell(tongluong)="data">{{
                        data.item.tongluong | numeral("0,0")
                      }}</template>
                      <template #cell(luongtheongaycong)="data">{{
                        data.item.luongtheongaycong | numeral("0,0")
                      }}</template>
                      <template #cell(luongthucnhan)="data">{{
                        data.item.luongthucnhan | numeral("0,0")
                      }}</template>
                      <template #cell(thunhapkhac)="data">{{
                        data.item.thunhapkhac | numeral("0,0")
                      }}</template>
                      <!-- <template #cell(thunhapkhac)="data">
                      <b-form-input :formatter="formatter" autocomplete="off" type="number" style="text-align: right;" :value="data.item.thunhapkhac" @change="updateThunhapkhac(data, $event)" :disabled="finalizelocked"/>
                    </template> -->
                      <!-- <template #cell(ghichu)="data">
                      <b-form-input autocomplete="off" :value="data.item.ghichu" @change="updateGhichu(data, $event)" :disabled="finalizelocked"/>
                    </template> -->
                      <template slot="bottom-row">
                        <td style="text-align:center" colspan="4">
                          <b>TOTAL</b>
                        </td>
                        <td style="text-align:right">
                          <b>{{ sum_tong_luong | numeral("0,0") }}</b>
                        </td>
                        <td style="text-align:right">
                          <b>{{ sum_luong_theo_ngay_cong | numeral("0,0") }}</b>
                        </td>
                        <td style="text-align:right">
                          <b>{{ sum_thu_nhap_khac | numeral("0,0") }}</b>
                        </td>
                        <td style="text-align:right">
                          <b>{{ sum_luong_thuc_nhan | numeral("0,0") }}</b>
                        </td>
                        <td></td>
                      </template>
                    </b-table>
                  </b-card>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <!-- <b-row style="width: 100%;">
            <b-col cols="12">

            </b-col>
          </b-row> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SalariesPayroll",
  data() {
    return {
      payrollFields: [
        {
          key: "tenbangluong",
          label: "Payroll name", // label: "Tên bảng lương",
          sortable: true,
          thClass: "align-middle",
          thStyle: {
            width: "auto",
            minWidth: "260px",
            maxWidth: "260px",
            textAlign: "center",
          },
        },
        {
          key: "year",
          label: "Year", // label: "Năm",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: {
            width: "80px",
            minWidth: "80px",
            maxWidth: "80px",
            textAlign: "center",
          },
        },
        {
          key: "month",
          label: "Month", // label: "Tháng",
          sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: {
            width: "80px",
            minWidth: "80px",
            maxWidth: "80px",
            textAlign: "center",
          },
        },
        {
          key: "departmentid",
          label: "Company", // label: "Đơn vị",
          sortable: true,
          thClass: "align-middle",
          thStyle: {
            width: "200px",
            minWidth: "200px",
            maxWidth: "200px",
            textAlign: "center",
          },
        },
        {
          key: "tong",
          label: "Total salary", // label: "Tổng lương",
          sortable: true,
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: {
            width: "160px",
            minWidth: "160px",
            maxWidth: "160px",
            textAlign: "center",
          },
        },
        {
          key: "mailsentat",
          label: "Sent email",
          sortable: true,
          thClass: "align-middle",
          thStyle: {
            width: "80px",
            minWidth: "80px",
            maxWidth: "80px",
            textAlign: "center",
          },
        },
        {
          key: "excel",
          label: "Export payroll", // label: "Xuất bảng lương",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: {
            width: "80px",
            minWidth: "80px",
            maxWidth: "80px",
            textAlign: "center",
          },
        },
      ],
      query: null,

      payrolls: [],
      departments: [],
      year_selected: 0,
      month_selected: 0,
      optionsMonth: [
        { value: 0, text: "All" },
        { value: 1, text: "January" },
        { value: 2, text: "February" },
        { value: 3, text: "March" },
        { value: 4, text: "April" },
        { value: 5, text: "May" },
        { value: 6, text: "June" },
        { value: 7, text: "July" },
        { value: 8, text: "August" },
        { value: 9, text: "September" },
        { value: 10, text: "October" },
        { value: 11, text: "November" },
        { value: 12, text: "December" },
      ],
      // optionsMonth: [{value: 0, text: "Tất cả"}, {value: 1, text: "Tháng 1"}, {value: 2, text: "Tháng 2"}, {value: 3, text: "Tháng 3"}, {value: 4, text: "Tháng 4"}, {value: 5, text: "Tháng 5"}, {value: 6, text: "Tháng 6"},
      // {value: 7, text: "Tháng 7"}, {value: 8, text: "Tháng 8"}, {value: 9, text: "Tháng 9"}, {value: 10, text: "Tháng 10"}, {value: 11, text: "Tháng 11"}, {value: 12, text: "Tháng 12"},],

      // headerSize: "1000000000000000px",
      salaries: [],
      salaryFields: [
        {
          key: "manhanvien",
          // label: "Mã NV",
          label: "Code",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "hovaten",
          label: "Name",
          // label: "Tên",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "vitricongviec",
          label: "Position",
          // label: "Chức vụ",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "ngaycong",
          label: "Work day",
          // label: "Ngày công",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "tongluong",
          label: "Total salary",
          // label: "Tổng lương",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "luongtheongaycong",
          label: "Salary based on work day",
          // label: "Lương theo ngày công",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "thunhapkhac",
          label: "Other income",
          // label: "Thu nhập khác",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "luongthucnhan",
          label: "Net salary",
          // label: "Lương thực nhận",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "ghichu",
          label: "Note",
          // label: "Ghi chú",1
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
      ],
      // selected: [],
    };
  },
  computed: {
    salary_read() {
      return this.$store.getters.hasPermission("salary_read");
    },
    optionsYear() {
      var result = [];
      var this_year = new Date().getFullYear();
      for (var i = 2020; i <= this_year; ++i) {
        result.push({ value: i, text: i });
      }
      result.sort((a, b) => (a.value > b.value ? -1 : 0));
      return result;
    },
    is_all_department() {
      return this.$store.state.auth.i == 0;
    },
    sum_luong_thuc_nhan() {
      var sum = 0;
      for (var item of this.salaries) {
        sum += item.luongthucnhan;
      }
      return sum;
    },
    sum_tong_luong() {
      var sum = 0;
      for (var item of this.salaries) {
        sum += item.tongluong;
      }
      return sum;
    },
    sum_luong_theo_ngay_cong() {
      var sum = 0;
      for (var item of this.salaries) {
        sum += item.luongtheongaycong;
      }
      return sum;
    },
    sum_thu_nhap_khac() {
      var sum = 0;
      for (var item of this.salaries) {
        sum += item.thunhapkhac;
      }
      return sum;
    },
    // Moi bang luong thang da bi lam tron
    sum_tong_luong_ck() {
      var sum = 0;
      for (var item of this.payrolls) {
        sum += Math.round(item.tong);
      }
      return sum;
    },
  },
  beforeRouteEnter(to, from, next) {
    axios
      .all([axios.get(`/api/salary/show`), axios.get("/api/department")])
      .then(
        axios.spread((payrolls, departments) => {
          next((vm) => vm.initData(payrolls.data, departments.data));
        })
      );
  },
  methods: {
    initData(payrolls, departments) {
      this.departments = departments;
      this.payrolls = payrolls;

      this.year_selected = new Date().getFullYear();
      this.month_selected = 0; //parseInt(new Date().getMonth() + 1);
    },
    // excelReportOld(year, month, departmentid) {
    //   let query = Object.assign({}, this.$route.query);

    //   // query.year = this.year_selected;
    //   // query.month = this.month_selected;
    //   query.year = year;
    //   query.month = month;
    //   query.depid = departmentid;
    //   axios({
    //     method: "get",
    //     url: `/api/salary/reportold`,
    //     params: query,
    //     responseType: "blob", // important
    //   })
    //     .then((res) => {
    //       let filename = res.headers["content-disposition"]
    //         .split(";")
    //         .find(function(el) {
    //           if (el.includes("filename=")) return el;
    //         })
    //         .replace("filename=", "")
    //         .trim();
    //       const url = window.URL.createObjectURL(
    //         new Blob([res.data], {
    //           type: "application/vnd.ms-excel;charset=utf-8",
    //         })
    //       );
    //       const link = document.createElement("a");
    //       link.href = url;
    //       link.setAttribute("download", filename); //or any other extension
    //       document.body.appendChild(link);
    //       link.click();
    //     })
    //     .catch((err) => {
    //       //   reject(err);
    //     });
    // },
    excelReport(year, month, departmentid) {
      let query = Object.assign({}, this.$route.query);

      query.year = year;
      query.month = month;
      query.depid = departmentid;
      axios({
        method: "get",
        url: `/api/salary/payrollsreport`,
        params: query,
        responseType: "blob", // important
      })
        .then((res) => {
          let filename = res.headers["content-disposition"]
            .split(";")
            .find(function(el) {
              if (el.includes("filename=")) return el;
            })
            .replace("filename=", "")
            .trim();
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          //   reject(err);
        });
    },
    sendEmail() {
      axios.post("/api/salary/test").then();
      // .catch((err) => {this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
      // })
    },

    queryItem() {
      let query = Object.assign({}, this.$route.query);
      query.q = this.query;
      query.year = this.year_selected;
      query.month = this.month_selected;

      axios.get("/api/salary/show", { params: query }).then((res) => {
        this.payrolls = res.data;
        //Xoa detail
        this.salaries = [];
        // this.selected = [];
      });
    },
    onRowClicked(row) {
      //#region Check row
      row._showDetails = !row._showDetails;
      if (this.old_row != null && this.old_row != row)
        this.old_row._showDetails = false;
      this.old_row = row;
      if (!row._showDetails) return;
      //#endregion

      var temp = document.getElementById("payroll-table").parentNode;
      var temp2 = document.getElementById("payroll-table");

      let query = Object.assign({}, this.$route.query);
      query.q = this.query;
      query.year = row.year;
      query.month = row.month;
      query.deptid = row.departmentid;

      axios
        .get("/api/salary/payroll", { params: query })
        .then((res) => {
          this.salaries = res.data;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        })
        .finally(() => {});
    },
    // onRowSelected(items) {
    //   this.selected = items;
    //   if (items.length > 0) {
    //     this.headerSize = "580px";
    //     if (items.length > 0) {
    //       let query = Object.assign({}, this.$route.query);
    //       query.q = this.query;
    //       query.year = items[0].year;
    //       query.month = items[0].month;
    //       query.deptid = items[0].departmentid;

    //       axios
    //         .get("/api/salary/payroll", { params: query })
    //         .then((res) => {
    //           this.salaries = res.data;
    //           this.selected = items;
    //         })
    //         .catch((err) => {
    //           this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
    //         });
    //     }
    //   }
    // },
    findFirstDepartment(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.tendonvi;
    },

    findFirstDepartmentShort(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.madonvi;
    },
  },
};
</script>
<style scoped>
body {
  overflow: hidden;
}
</style>
<style>
/*#region salaries payroll table*/
#salaries_payroll_fluid .b-table-sticky-header {
  height: calc(100vh - 130px);
  max-height: unset;
  min-height: unset;
  margin-bottom: 0rem;
}
#salaries_payroll_fluid .b-table-bottom-row td {
  padding: 0.1rem;
  color: #fff;
  background-color: #5384d1;
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  z-index: 2;
}
/*#endregion salaries payroll  table*/
</style>
